import { resolvePortValue, type NodeImplementation } from '@spotar/runtime';

type TrayInputStateTarget = {
  setInputDisabled: (isDisabled: boolean) => void;
};

function supportsInputState(target: unknown): target is TrayInputStateTarget {
  if (!target || typeof target !== 'object') return false;
  return 'setInputDisabled' in target && typeof target.setInputDisabled === 'function';
}

function setTrayInputDisabled(data: Record<string, unknown>, isDisabled: boolean) {
  const target = resolvePortValue(data.element);
  if (!supportsInputState(target)) {
    throw new Error('the wired tray element does not support input state changes');
  }
  target.setInputDisabled(isDisabled);
}

export const runTrayDisableInputImplementation: NodeImplementation = (data) => {
  setTrayInputDisabled(data, true);
};

export const runTrayEnableInputImplementation: NodeImplementation = (data) => {
  setTrayInputDisabled(data, false);
};
